import { render, staticRenderFns } from "./MainloadingServe.vue?vue&type=template&id=0b4bb41f&"
import script from "./MainloadingServe.vue?vue&type=script&lang=js&"
export * from "./MainloadingServe.vue?vue&type=script&lang=js&"
import style0 from "./MainloadingServe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports